export default {
  development: {
    url: 'http://kea.th/_/moya/kort/api/'
  },
  production: {
    url: 'https://www.kea.is/_/moya/kort/api/'
  }
};